<div class="d-flex align-items-center">
  <button mat-flat-button (click)="clickButton.emit()" [ngClass]="{ feasibility: isBtnFeasibility }"
    class="btn btn-custom-pink shadow {{ isRounded ? 'border-round' : '' }}" [disabled]="isDisabled">
    <div #buttonTextRef>
      <ng-content></ng-content>
    </div>
  </button>
  <mat-spinner *ngIf="isWaitingBuildings && (selectedPoints[0] || selectedFile)" [diameter]="20" class="ml-3"></mat-spinner>
</div>